import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import asyncComponent from "../../../util/asyncComponent";

const ServiceCenter = ({ match }) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const hasAccess = authUser && authUser.Claims.includes("admin.access");

  return (
    <div className="app-wrapper">
      <Switch>
        {hasAccess && (
          <Redirect exact from={`${match.url}/`} to={`${match.url}/trading`} />
        )}
        {hasAccess && (
          <Redirect exact from={match.url} to={`${match.url}/trading`} />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/trading`}
            component={asyncComponent(() => import("./routes/Trading"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/account`}
            component={asyncComponent(() => import("./routes/Account"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/account-transfers`}
            render={({ location }) => (
              <Redirect
                to={{
                  pathname: "/app/account-transfers/activity",
                  search: location.search,
                }}
              />
            )}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/batch-ops`}
            component={asyncComponent(() => import("./routes/BatchOps"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/rotation-ops`}
            component={asyncComponent(() => import("./routes/RotationOps"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/scoped-liquidation`}
            component={asyncComponent(() => import("./routes/ScopedLiquidation"))}
          />
        )}
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default ServiceCenter;
